import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { GLOBAL_FIELD_NAMES, globalPrefix } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

export const GoalsExecSum: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = true;

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('executiveSummary.title')}
          badgeText={t('executiveSummary.goalsAndObjectives.title')}
          section={FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY}
        />
      </FormSectionCard>
      {/* 1.1.1 */}
      <FormSectionCard
        title={t('executiveSummary.goalsAndObjectives.mainGoals')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_GOALS)}
      >
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.goalsAndObjectives.mainGoals"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_GOALS)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      {/* 1.1.2 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.goalsAndObjectives.briefProjectDescription')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION)}
        aiOnlyUpdate
      >
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.goalsAndObjectives.briefProjectDescription"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      {/* 1.1.3 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.goalsAndObjectives.strategy')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.STRATEGY_FOR_ACHIEVING_GOALS)}
      >
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.goalsAndObjectives.strategy"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.STRATEGY_FOR_ACHIEVING_GOALS)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
    </>
  );
};
